module.exports = __webpack_public_path__ + "static/img/btn-tablet.cf80433.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/instructions/img/btn-tablet.png
// module id = HWuE
// module chunks = 0